import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import { Box, IconButton, Link, Stack } from "@mui/material";
import { LanguageItem } from "./types";

const HeaderMenu = ({
  pageLanguages,
  onClick,
  onHomeIconClick,
}: {
  pageLanguages: Array<LanguageItem>;
  onClick: (item: LanguageItem) => void;
  onHomeIconClick: () => void;
}) => (
  <>
    <Stack direction="row" spacing={1} divider={<Box lineHeight={1}>|</Box>}>
      {pageLanguages?.map((item) => (
        <Link
          key={item.languageName}
          color="common.white"
          fontSize="0.75rem"
          fontWeight="600"
          href={item?.isDefault ? undefined : ""}
          underline={item?.isDefault ? "none" : "hover"}
          onClick={(e) => {
            e.preventDefault();
            onClick(item);
          }}
        >
          {item.languageName}
        </Link>
      ))}
    </Stack>
    <IconButton
      color="inherit"
      edge="start"
      onClick={() => {
        onHomeIconClick();
      }}
      size="small"
      sx={{ pr: 0, pt: 0 }}
    >
      <HomeOutlinedIcon sx={{ fontSize: "24px" }} />
    </IconButton>
  </>
);

export default HeaderMenu;
